export const aciSeparateBedroom = {
    iconName: 'separate-bedroom',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M7.24 3.462a1.176 1.176 0 00-1.08 1.072c-.004.054-.007 2.618-.007 7.591v7.509l-.902.002-.903.002-.046.017a.485.485 0 00-.289.31.525.525 0 00.007.261.479.479 0 00.306.3c.043.012.288.012 7.675.012 7.386 0 7.632 0 7.674-.013a.447.447 0 00.178-.104.42.42 0 00.147-.33.404.404 0 00-.05-.217.491.491 0 00-.25-.219l-.047-.017-.902-.002-.903-.002-.002-7.567c-.002-6.881-.003-7.572-.014-7.626a1.186 1.186 0 00-.965-.967c-.05-.01-.48-.012-4.827-.013l-4.8.001zm.046.911a.276.276 0 00-.204.165l-.017.042-.002 7.524-.002 7.523H16.94l-.002-7.523-.002-7.524-.017-.043a.306.306 0 00-.15-.15l-.043-.018h-4.704c-2.586-.001-4.718 0-4.736.004zm7.295 6.912a.723.723 0 10.817.89.546.546 0 00.018-.175.546.546 0 00-.018-.175.723.723 0 00-.817-.54z',
                fill: 'currentColor',
            },
        },
    },
};
